import { Link } from "react-router-dom";
import { AlertTriangle, Gauge } from "lucide-react";
import { useLicenseSummary } from "./licenseUtil";

const MSG = {
  warning: (s) => `You've used ${s.used} of ${s.allowance} interviews this month.`,
  grace: (s) => `All ${s.allowance} included interviews are used — extra interviews now use the grace allowance.`,
  blocked: () => "Interview limit reached — new invites are paused. Candidates already invited can still finish.",
  trial_ended: () => "Your free trial has ended — choose a plan to keep inviting candidates.",
};

// Overview banner, shown to admins only when usage needs attention.
export function LicenseBanner() {
  const s = useLicenseSummary();
  if (!s || !MSG[s.state]) return null;
  const red = s.state === "blocked" || s.state === "trial_ended";
  return (
    <div data-testid="license-banner" data-state={s.state}
      className={`mb-6 flex flex-wrap items-center gap-3 rounded-xl border px-4 py-3 text-sm ${red ? "bg-rose-50 border-rose-200 text-rose-800" : "bg-amber-50 border-amber-200 text-amber-800"}`}>
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span className="flex-1 min-w-0">{MSG[s.state](s)}</span>
      <Link to="/app/licenses" data-testid="license-banner-link" className="font-medium underline underline-offset-2">View plan &amp; usage</Link>
    </div>
  );
}

// Small "N interviews left" hint for invite dialogs (admins only).
export function LicenseHint() {
  const s = useLicenseSummary();
  if (!s || s.unlimited) return null;
  const low = s.remaining <= Math.max(3, Math.round((s.allowance || 0) * 0.1));
  return (
    <div data-testid="license-hint" className={`flex items-center gap-1.5 text-xs mb-4 ${low ? "text-rose-600" : "text-slate-500"}`}>
      <Gauge className="w-3.5 h-3.5" /> {s.remaining} interview{s.remaining === 1 ? "" : "s"} left this month (incl. credits &amp; grace)
    </div>
  );
}
